export class Person {
    
    personId:string;
    fullname:string;
    professionaldesc?:string;
    email:string;
    im?:string;
    address?:string;
    address2?:string;
    zip?:string;
    city?:string;
    phone?:string;
    avatarurl?:string;
    et_admin?:boolean;
    defaultorg?:string;
}